import { get } from '../../../utils';
import { MapCategory, MapConfiguration, PortAndWaterwayObject } from '../../../types';
import { Dispatch, UnknownAction } from 'redux';

export enum MapAction {
  LOAD_OBJECTS = 'LOAD_OBJECTS',
  LOADING_OBJECTS = 'LOADING_OBJECTS',
  LOAD_CATEGORIES = 'LOAD_CATEGORIES',
  LOADING_CATEGORIES = 'LOADING_CATEGORIES',
  LOAD_CONFIGURATION = 'LOAD_CONFIGURATION',
  LOADING_CONFIGURATION = 'LOADING_CONFIGURATION',
  TOGGLE_CATEGORY = 'TOGGLE_CATEGORY',
  UPDATE_FILTER_TEXT = 'UPDATE_FILTER_TEXT',
  SORT_GEO = 'SORT_GEO',
}

export interface MapActions extends UnknownAction {
  type: MapAction;
  objects?: PortAndWaterwayObject[];
  loadingObjects?: boolean;
  categories?: MapCategory[];
  loadingCategories?: boolean;
  configuration?: MapConfiguration;
  loadingConfiguration?: boolean;
  category?: MapCategory;
  text?: string;
}

export const sortGeoAction = (): MapActions => ({
  type: MapAction.SORT_GEO,
});

const startLoadingObjectsAction = (loadingObjects: boolean) => ({
  type: MapAction.LOADING_OBJECTS,
  loadingObjects,
});

const startLoadingCategoriesAction = (loadingCategories: boolean) => ({
  type: MapAction.LOADING_CATEGORIES,
  loadingCategories,
});

const loadObjectsAction = (objects): MapActions => ({
  type: MapAction.LOAD_OBJECTS,
  objects,
});

const loadMapCategoriesAction = (categories): MapActions => ({
  type: MapAction.LOAD_CATEGORIES,
  categories,
});

const loadConfiguration = (configuration: MapConfiguration): MapActions => ({
  type: MapAction.LOAD_CONFIGURATION,
  configuration,
});

const startLoadingConfigurationAction = (loadingConfiguration: boolean): MapActions => ({
  type: MapAction.LOADING_CONFIGURATION,
  loadingConfiguration,
});

export const toggleCategoryAction = (category: MapCategory): MapActions => ({
  type: MapAction.TOGGLE_CATEGORY,
  category,
});

export const updateFilterTextAction = (text: string): MapActions => ({
  type: MapAction.UPDATE_FILTER_TEXT,
  text,
});

export const fetchObjects = (dispatch: Dispatch) => (): Promise<PortAndWaterwayObject[]> =>
  Promise.resolve(dispatch(startLoadingObjectsAction(true))).then(() =>
    get<PortAndWaterwayObject[]>('/api/sxk-map/port-and-waterway-objects')
      .then((portAndWaterwayObjects: PortAndWaterwayObject[]) => {
        dispatch(loadObjectsAction(portAndWaterwayObjects));
        return portAndWaterwayObjects;
      })
      .catch((error) => {
        console.error(error);
        return [];
      })
      .finally(() => {
        dispatch(startLoadingObjectsAction(false));
      })
  );

export const NO_CONFIGURATION = Object.freeze({
  recaptchaSiteKey: '',
  isAnonymous: true,
  createArticle: false,
  createMemberTip: false,
  createImage: false,
  createPaKryss: false,
});

export const fetchConfiguration = (dispatch: Dispatch) => (): Promise<MapConfiguration> =>
  Promise.resolve(dispatch(startLoadingConfigurationAction(true))).then(() =>
    get<MapConfiguration>('/api/sxk-map/configuration')
      .then((configuration: MapConfiguration) => {
        const conf = configuration || NO_CONFIGURATION;
        dispatch(loadConfiguration(conf));
        return conf;
      })
      .catch((error) => {
        console.error(error);
        dispatch(loadConfiguration(NO_CONFIGURATION));
        return NO_CONFIGURATION;
      })
      .finally(() => {
        dispatch(startLoadingConfigurationAction(false));
      })
  );

export const fetchMapCategories = (dispatch: Dispatch) => (): Promise<MapCategory[]> =>
  Promise.resolve(dispatch(startLoadingCategoriesAction(true))).then(() =>
    get<MapCategory[]>('/api/sxk-map/categories')
      .then((categories: MapCategory[]) => {
        dispatch(loadMapCategoriesAction(categories));
        return categories;
      })
      .catch((error) => {
        console.error(error);
        return [];
      })
      .finally(() => {
        dispatch(startLoadingCategoriesAction(false));
      })
  );
